<template>
  <v-card v-if="dataBurbuja">
    <v-toolbar card>
      <v-icon>domain</v-icon>
      <v-toolbar-title class="font-weight-light">Datos desde el formulario cumplimentado por los usuarios - {{ CA }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="px-5 blue--text">
      <v-flex xs12>
        <v-layout row justify-space-between>
          <v-flex xs3>
            <v-text-field label="Escalera" v-model="ubicacion.escalera"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field label="Piso" v-model="ubicacion.piso"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field label="Letra" v-model="ubicacion.letra"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <!-- <v-text-field label="Uso" v-model="inmuebleDatos.uso"></v-text-field> -->
      </v-flex>
    </v-card-text>

    <!-- BurbujaPropietarios -->
    <v-card-text>
      <v-flex xs12 sm12 v-for="(propietario, i) in propietarios" :key="i">
        <BurbujaPropietario
          :propietario="propietario.data"
          :uid="propietario.sessionUid" 
          :refCatastral="refCatastral" 
          :idInmueble="idInmueble"
          :CA="CA"
          @consolidar="consolida"
          @archivar="archiva"
        />
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn color="success" @click.stop="inmuebleDatosUpdate">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn> -->
    </v-card-actions>
    <template v-if="debug">
      <pre>{{dataBurbuja}}</pre>
    </template>
  </v-card>
  <v-card v-else>
    <v-toolbar card>
      <v-icon>domain</v-icon>
      <v-toolbar-title class="font-weight-light">No existen datos desde el formulario para usuarios</v-toolbar-title>
    </v-toolbar>
  </v-card>
</template>

<script>
import BurbujaPropietario from "./inmueble-burbuja-propietarios"
export default {
  props: ["dataBurbuja", "refCatastral", "idInmueble", "CA", "debug"],
  components: {BurbujaPropietario},
  data () {
    return {
      ubicacion: {},
      propietarios: []
    }
  },

  mounted() {
    this.cargaDatos();
  },

  watch: {
    dataBurbuja() {
      this.cargaDatos();
    }
  },

  methods: {
    consolida(datos) {
      /**
       * datos = {
          propietarioBurbuja: this.dataPropietario,
          sessionUid: this.uid
        }
      */
      const data = {
        propietarioBurbuja: datos.propietarioBurbuja,
        sessionUid: datos.sessionUid,
      }
      this.$emit('consolida', datos)
      
    },

    archiva(datos) {
      const data = {
        refCat: this.refCatastral,
        refInmueble: this.idInmueble,
        sessionUid: datos.sessionUid,
        noMostrar: true
      }
      this.$emit('archivar', data)
      console.log(data)
    },

    cargaDatos() {
      const datos = Object.assign({}, this.dataBurbuja);
      if (!datos || !datos.propietarios) {
        this.propietarios = [];
        this.ubicacion = {};
        return;
      }
      // console.log(JSON.stringify(datos));
      // this.propietarios = datos.propietarios; // Object.assign({}, this.dataBurbuja.propietarios);

      this.propietarios = datos.propietarios.filter(i => !i.noMostrar);
      this.ubicacion = {
        escalera: datos.escalera,
        piso: datos.piso,
        letra: datos.letra
      }
    },

    inmuebleDatosUpdate() {
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleDatos: this.inmuebleDatos
      };
      this.$store.dispatch("inmuebleDatosUpdate", payload);
      this.$emit("listo");
      // this.hecho = true;
    }
  }
}
</script>
